// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './components/login/login.component';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { LoginHeaderComponent } from './components/login-header/login-header.component';
import { ResetPasswordLinkComponent } from './components/reset-password-link/reset-password-link.component';
import { RouterModule } from '@angular/router';
import { TrimDirective } from './directives/trim.directive';

@NgModule({
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    TranslateModule.forChild(),
    ReactiveFormsModule,
    MatIconModule,
    RouterModule,
  ],
  declarations: [
    LoginComponent,
    ResetPasswordComponent,
    ChangePasswordComponent,
    LoginHeaderComponent,
    ResetPasswordLinkComponent,
    TrimDirective,
  ],
  exports: [
    LoginComponent,
    ResetPasswordComponent,
    ChangePasswordComponent,
    LoginHeaderComponent,
    ResetPasswordLinkComponent,
  ],
})
export class LibAuthModule {
}
